import { Instance, types } from 'mobx-state-tree';
import { SessionStepModel } from './SessionStepModel';

export const SessionModel = types.model('SessionModel', {
  _id: types.identifier,
  title: types.maybeNull(types.string),
  shortDescription: types.maybeNull(types.string),
  humanReadableId: types.maybeNull(types.string),
  dateCreated: types.maybeNull(types.string),
  type: types.maybeNull(types.string),
  order: types.number,
  language: types.string,
  summary: types.maybeNull(types.string),
  duration: types.maybeNull(types.number),
  userSessionId: types.maybeNull(types.string),
  wasDoneToday: types.maybeNull(types.boolean),
  contentLoaded: types.maybeNull(types.boolean),
  done: types.maybeNull(types.boolean),
  userSessionOrder: types.maybeNull(types.number),
  sessionSteps: types.maybeNull(types.array(SessionStepModel)),
  fromPath: types.boolean,
  fromReckoning: types.boolean,
  path:types.maybeNull(types.string),
  reckoning: types.maybeNull(types.string),
  lastFrameIndex: types.maybeNull(types.number),
  userSegments: types.maybeNull(types.array(types.string))
});

export type ISession = Instance<typeof SessionModel>;
